import { RENDERED_PAGE_INDEX } from "./constants";
import type { PlanV3, ScaledRoute } from "../../../utils/types";
import type { VisualDiffPoint } from "./types";

export const euclideanDistance = (
  firstPoint: VisualDiffPoint,
  secondPoint: VisualDiffPoint,
): number =>
  Math.hypot(firstPoint.x - secondPoint.x, firstPoint.y - secondPoint.y);

export const extentsCenter = (route: ScaledRoute): VisualDiffPoint => ({
  x: (route.coordinateExtents.minX + route.coordinateExtents.maxX) / 2,
  y: (route.coordinateExtents.minY + route.coordinateExtents.maxY) / 2,
});

export const groupByPage = <TItem>(
  items: TItem[],
  getPage: (item: TItem) => number,
): Map<number, TItem[]> => {
  const itemsByPage = new Map<number, TItem[]>();
  for (const item of items) {
    const page = getPage(item);
    const pageItems = itemsByPage.get(page);
    if (pageItems === undefined) {
      itemsByPage.set(page, [item]);
      continue;
    }
    pageItems.push(item);
  }
  return itemsByPage;
};

export const resolveTolerancePdfPoints = (
  beforePlan: PlanV3,
  afterPlan: PlanV3,
  toleranceMeters: number,
  fallbackPdfPoints: number,
): number => {
  const afterCalibration =
    afterPlan.metersPerPdfPointByPageIndex.get(RENDERED_PAGE_INDEX);
  const beforeCalibration =
    beforePlan.metersPerPdfPointByPageIndex.get(RENDERED_PAGE_INDEX);
  // 0 means uncalibrated, not "zero meters per point".
  const metersPerPdfPoint =
    afterCalibration !== undefined && afterCalibration !== 0
      ? afterCalibration
      : beforeCalibration !== undefined && beforeCalibration !== 0
        ? beforeCalibration
        : null;
  if (metersPerPdfPoint === null) return fallbackPdfPoints;
  return toleranceMeters / metersPerPdfPoint;
};
